
import { cssdApiClients } from "../../../http-common";
import authHeader from "../../../authentication/authservices/auth-header";

// export const autoSearchCssdItemKit = (searchString, type) => {
//     return cssdApiClients.get(
//         `/itemkit/getCssdOrPharmacyConditional?searchString=${searchString}&searchType=${type}`,
//         {
//             headers: authHeader(),
//         }
//     );
// };


// export const autoSearchCssdItemKit = (searchString) => {
//     return cssdApiClients.get(`/cssd/getCssdOrPharmacyConditional/${searchString}`, {
//         headers: authHeader()
//     });
// };


export const autoSearchCssdItemKit = (type) => {
    console.log("search keit", type);

    return cssdApiClients.get(`/cssd/kit`, {
        headers: authHeader(),
    });
};

export const autoSearchCssdItemItem = (type) => {
    return cssdApiClients.get(`/cssd/item`, {
        headers: authHeader(),
    });
};

// export const getStoreDropdown = (unitId) => {
//     return cssdApiClients.get(`/store/getStore/${unitId}`, { headers: authHeader() });
// };

// export const getStoreDropdown = () => {
//     return cssdApiClients.get(`/cssd/getStore`, {
//         headers: authHeader()
//     });
// };

export const getStoreDropdown = (search) => {
    return cssdApiClients.get(`/cssd/getStore/${search}`, {
        headers: authHeader()
    });
};
// export const autoSearchSurgeonName = () => {
//     return cssdApiClients.get(`/cssd/doctordropdown`, {
//         headers: authHeader()
//     });
// };

export const autoSearchSurgeonName = (search) => {
    return cssdApiClients.get(`/cssd/doctordropdown/${search}`, {
        headers: authHeader()
    });
};


export const autoSearchHandoverReceived = (search) => {
    return cssdApiClients.get(`/cssd/empdropdown/${search}`, {
        headers: authHeader()
    });
};

// export const autoSearchHandoverReceived = () => {
//     return cssdApiClients.get(`/cssd/empdropdown`, {
//         headers: authHeader()
//     });
// };

export const getItemsinItemKitById = (storeId, unitId, kitId) => {
    return cssdApiClients.get(`/item/getItemsByKit/${storeId}/${unitId}/${kitId}`, {
        headers: authHeader(),
    });
};


export const deletecleaningwrappingItem = (id) => {
    return cssdApiClients.get(`/cssd/deleteItem/${id}`, {
        headers: authHeader(),
    });
};

